import { Modal } from "react-bootstrap";
import { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { insertCertificate,GetCertificate } from "../../apis/api/CertificateApi";

const AddDocumentUpload = ({ show, handleClose }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setValue("file", file, { shouldValidate: true });
    }
  };

  const removeFile = () => {
    setSelectedFile(null);
    setValue("file", null);
  };

  const onSubmit = async (data) => {
    const userid = Cookies.get("userID");
    const companyid = Cookies.get("company_id");

    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("file", selectedFile);
    formData.append("userid", userid || "");
    formData.append("companyid", companyid || "");

    const response = await dispatch(insertCertificate(formData));

    if (response.payload?.status === "success") {
      toast.success("Certificate inserted successfully!");
      await dispatch(GetCertificate({company_id:companyid}));
      handleClose(true);
    } else {
      toast.error("Error while inserting certificate!");
    }
  };

  const getFileIcon = (file) => {
    const ext = file.name.split(".").pop()?.toLowerCase() || "";
    if (["pdf"].includes(ext)) return "bx bxs-file-pdf text-danger";
    if (["doc", "docx"].includes(ext)) return "bx bxs-file-doc text-primary";
    if (["xls", "xlsx"].includes(ext)) return "bx bxs-file text-success";
    return "bx bx-file";
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="file-upload-container container-upload">
          <input
            type="text"
            placeholder="Enter Document Title"
            className={`form-control mb-3 ${errors.title ? "is-invalid" : ""}`}
            {...register("title", { required: "Title is required" })}
          />
          {errors.title && <div className="invalid-feedback">{errors.title.message}</div>}

          {!selectedFile && (
            <div
              className="header12"
              onClick={() => fileInputRef.current?.click()}
              style={{ cursor: "pointer" }}
            >
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10C19.2091 10 21 11.7909 21 14C21 15.4806 20.1956 16.8084 19 17.5M7 10C4.79086 10 3 11.7909 3 14C3 15.4806 3.8044 16.8084 5 17.5M12 12V21M12 12L15 15M12 12L9 15"
                  stroke="#000"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p>Browse file to upload</p>
            </div>
          )}

          {selectedFile && (
            <div className="preview-container">
              <div className="preview-item d-flex align-items-center gap-2">
                {selectedFile.type.startsWith("image/") ? (
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="Preview"
                    className="preview-img"
                    style={{ height: "50px", width: "50px", objectFit: "cover" }}
                  />
                ) : (
                  <i className={`${getFileIcon(selectedFile)} fs-2`}></i>
                )}
                <span className="text-truncate" style={{ maxWidth: "200px" }}>
                  {selectedFile.name}
                </span>
                <button type="button" className="btn btn-sm btn-danger ms-auto" onClick={removeFile}>
                  ✖
                </button>
              </div>
            </div>
          )}

          <input type="file" ref={fileInputRef} onChange={handleFileChange} hidden />
          {errors.file && <div className="text-danger mt-2">Please select a valid file</div>}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary" onClick={handleSubmit(onSubmit)}>Upload</button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddDocumentUpload;
